import { SalesCommission, TSalesCommissionId, TUserId } from '/src/lib/models';
import { TResponseMetadata } from '/src/lib/types';

/**
 * List Sales Commissions
 */
export type TListSalesCommissionsRequest = {
  limit?: number;
  page?: number;
};

export type TListSalesCommissionsResponse = {
  meta: TResponseMetadata;
  data: SalesCommission[];
};

/**
 * Get Sales Commission
 */
export type TGetSalesCommissionRequest = {
  id: TSalesCommissionId;
};

export type TGetSalesCommissionResponse = SalesCommission;

/**
 * Create Sales Commission
 */
export type TCreateSalesCommissionRequest = {
  client_id: number;
  user_id: TUserId;
  percent_rate: number;
  reporting_period_type_id: number;
  start_reporting_quarter: string;
  end_reporting_quarter: string | null;
};

export type TCreateSalesCommissionResponse = SalesCommission;
